const DIVISIONS: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, unit: "seconds" },
  { amount: 60, unit: "minutes" },
  { amount: 24, unit: "hours" },
  { amount: 7, unit: "days" },
  { amount: 4.34524, unit: "weeks" },
  { amount: 12, unit: "months" },
  { amount: Number.POSITIVE_INFINITY, unit: "years" },
];

const formatter = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

/**
 * Formats a timestamp (ms since epoch) as a human-readable relative time,
 * e.g. "5 minutes ago" or "in 2 days".
 */
export const relativeTime = (timestamp: number): string => {
  let duration = (timestamp - Date.now()) / 1000;

  for (const { amount, unit } of DIVISIONS) {
    if (Math.abs(duration) < amount) {
      return formatter.format(Math.round(duration), unit);
    }
    duration /= amount;
  }

  return formatter.format(Math.round(duration), "years");
};
